module.exports = " <li v-link=link :class=classes _v-d56219ec=\"\"> <slot _v-d56219ec=\"\"></slot> </li> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/template-rewriter.js?id=_v-d56219ec!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ListItem.vue
// module id = 775
// module chunks = 2